// Price.jsx
import React, { useState, useEffect } from "react";
import {
    getPricePart,
    getPricePartWorks,
    newPricePart,
    newPriceWork,
    savePriceDoctor,
    savePricePart,
    deletePricePart,
    deletePriceWork,
    getHasCustomPrices,
} from "./orderApi";
import { useDispatch, useSelector } from "react-redux";
import { selectLanguage, selectRole, selectUserId } from "../../Login/loginSlice";
import { texts } from "../../Common/common";
import { intFormat } from "../../Common/funcs";
import './Price.css'


export const Price = (props) => {
    const { setShowPrice, setHasCustomPrices, doctor_id } = props;
    const dispatch = useDispatch();

    const [listPricePart, setListPricePart] = useState([]);
    const [listWorks, setListWorks] = useState([]);
    const [showWorks, setShowWorks] = useState(false);
    const [partName, setPartName] = useState("");
    const [partId, setPartId] = useState(0);
    const [showNewWork, setShowNewWork] = useState(false);
    const [showEditPart, setShowEditPart] = useState(false);
    const [showNewPricePart, setShowNewPricePart] = useState(false);
    const [showLoad, setShowLoad] = useState(false);
    const [nameNewWork, setNameNewWork] = useState("");
    const [nameEditPricePart, setNameEditPricePart] = useState("");
    const [nameNewPricePart, setNameNewPricePart] = useState("");
    const [priceNewWork, setPriceNewWork] = useState(0);
    const [deleteMode, setDeleteMode] = useState(false);
    const [modified, setModified] = useState(false);

    const userId = useSelector(selectUserId);
    const currentLanguage = useSelector(selectLanguage);
    const role = useSelector(selectRole);
    const is_doctor = role === "doctor";

    useEffect(() => {
        getPricePart({ customer_id: userId }, (data) => {
            setListPricePart(data.parts);
        });
    }, [userId]);

    const handleClickPart = (id, name) => {
        console.log('handleClickPart', id, name)
        setPartName(name);
        setPartId(id);
        getPricePartWorks({ id, doctor_id }, (data) => {
            setListWorks(data.works);
            setShowWorks(true);
        });
    };

    const handleLongPressPart = (id, name) => {
        setPartId(id);
        setNameEditPricePart(name);
        setShowEditPart(true);
    };

    const handleBack = () => {
        if (showWorks) {
            savePriceDoctor({ works: listWorks, doctor_id }, () => {
                getHasCustomPrices({ user_id: userId, doctor_id }, (res) => {
                    if (res.res) setHasCustomPrices(res.hasCustomPrices);
                });
            });
        }
        // dispatch(setHideTabBar(false)); todo
        showWorks ? setShowWorks(false) : setShowPrice(false);
    };

    const handleSaveWorks = () => {
        savePriceDoctor({ works: listWorks, doctor_id }, () => {
            getPricePartWorks({ id: partId, doctor_id }, (data) => {
                setListWorks(data.works);
                setModified(false);
            });
        });
    };

    const handleChangeWorkName = (value, index) => {
        const arr = [...listWorks];
        arr[index].name = value;
        setListWorks(arr);
        setModified(true);
    };

    const handleChangePrice = (value, index) => {
        const arr = [...listWorks];
        arr[index].price = value;
        setListWorks(arr);
        setModified(true);
    };

    const handleChangeDefaultPrice = (value, index) => {
        const arr = [...listWorks];
        arr[index].default_price = value;
        setListWorks(arr);
        setModified(true);
    };

    const handleDeleteWork = (id, name) => {
        if (window.confirm(`Удалить "${name}"?`)) {
            setShowLoad(true);
            deletePriceWork({ id }, () => {
                setShowLoad(false);
                getPricePartWorks({ id: partId, doctor_id }, (data) => {
                    setListWorks(data.works);
                    setShowNewWork(false);
                });
            });
        }
    };

    const handlePressOkNewWork = () => {
        newPriceWork({ part_id: partId, default_price: priceNewWork, name: nameNewWork }, () => {
            getPricePartWorks({ id: partId, doctor_id }, (data) => {
                setListWorks(data.works);
                setShowNewWork(false);
            });
        });
    };

    const handleNewWork = () => {
        setNameNewWork("");
        setPriceNewWork(0);
        setShowNewWork(true);
    };

    const handleNewPricePart = () => {
        setNameNewPricePart("");
        setShowNewPricePart(true);
    };

    const handleAddNewPricePart = () => {
        newPricePart({ name: nameNewPricePart, customer_id: userId }, () => {
            getPricePart({ customer_id: userId }, (data) => {
                setListPricePart(data.parts);
                setShowNewPricePart(false);
            });
        });
    };

    const handleSavePricePart = () => {
        savePricePart({ part_id: partId, name: nameEditPricePart }, () => {
            getPricePart({ customer_id: userId }, (data) => {
                setListPricePart(data.parts);
                setShowEditPart(false);
            });
        });
    };

    const handleDelPricePart = () => {
        deletePricePart({ part_id: partId }, () => {
            getPricePart({ customer_id: userId }, (data) => {
                setListPricePart(data.parts);
                setShowEditPart(false);
            });
        });
    };

    return (
        <div className="price-container">
            <button className="back-button" onClick={handleBack}>
                ← Назад
            </button>
            <h2 style={{textAlign: 'center'}}>{texts[currentLanguage].price}</h2>

            {/* Контейнер кнопок действий */}
            <div className="price-actions">
                {/* Добавить раздел / работу */}
                {!modified && !is_doctor && (
                    <button
                        className="action-button add-button"
                        onClick={showWorks ? handleNewWork : handleNewPricePart}
                        title="Добавить"
                    >
                        +
                    </button>
                )}

                {/* Кнопка удаления */}
                {showWorks && !modified && !is_doctor && (
                    <button
                        className="action-button delete-button"
                        onClick={() => setDeleteMode(!deleteMode)}
                        title="Удалить"
                    >
                        🗑
                    </button>
                )}

                {/* Сохранить изменения */}
                {modified && (
                    <button
                        className="action-button save-button"
                        onClick={handleSaveWorks}
                        title="Сохранить"
                    >
                        ✔
                    </button>
                )}
            </div>


            {/* Список разделов */}
            {!showWorks && (
                <div className="price-parts-container">
                    {listPricePart.map((part) => (
                        <div
                            key={part.id}
                            className="price-part"
                            onClick={() => handleClickPart(part.id, part.name)}
                            onContextMenu={(e) => {
                                e.preventDefault();
                                handleLongPressPart(part.id, part.name);
                            }}
                        >
                            {part.name}
                        </div>
                    ))}
                </div>
            )}


            {/* Работы */}
            {showWorks && (
                <div className="works-container">
                    <h3>{partName}</h3>
                    <div className="works-list">
                        {listWorks.map((work, index) => (
                            <div key={index} className="work-row">
                                <input
                                    type="text"
                                    value={work.name.trim()}
                                    onChange={(e) =>
                                        handleChangeWorkName(e.target.value, index)
                                    }
                                    disabled={is_doctor}
                                />
                                <input
                                    type="number"
                                    value={work.default_price}
                                    onChange={(e) =>
                                        handleChangeDefaultPrice(e.target.value, index)
                                    }
                                    disabled={is_doctor}
                                />
                                <input
                                    type="number"
                                    value={
                                        work.price && work.price !== work.default_price
                                            ? work.price
                                            : ""
                                    }
                                    onChange={(e) =>
                                        handleChangePrice(e.target.value, index)
                                    }
                                    disabled={is_doctor}
                                    className={
                                        work.price && work.price !== work.default_price
                                            ? "highlight"
                                            : ""
                                    }
                                />
                                {deleteMode && (
                                    <button
                                        className="delete-work"
                                        onClick={() => handleDeleteWork(work.id, work.name)}
                                    >
                                        ✖
                                    </button>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {/* Модальные окна */}
            {showLoad && (
                <div className="modal">
                    <div className="modal-content">Ожидание...</div>
                </div>
            )}

            {showNewWork && (
                <div className="modal">
                    <div className="modal-content">
                        <button className="close" onClick={() => setShowNewWork(false)}>
                            ✖
                        </button>
                        <h4>Новая работа</h4>
                        <label>
                            Название:
                            <input
                                value={nameNewWork}
                                onChange={(e) => setNameNewWork(e.target.value)}
                            />
                        </label>
                        <label>
                            Цена:
                            <input
                                type="number"
                                value={priceNewWork}
                                onChange={(e) => setPriceNewWork(intFormat(e.target.value))}
                            />
                        </label>
                        <button onClick={handlePressOkNewWork}>OK</button>
                    </div>
                </div>
            )}

            {showNewPricePart && (
                <div className="modal">
                    <div className="modal-content">
                        <button className="close" onClick={() => setShowNewPricePart(false)}>
                            ✖
                        </button>
                        <h4>Новый раздел</h4>
                        <input
                            value={nameNewPricePart}
                            onChange={(e) => setNameNewPricePart(e.target.value)}
                        />
                        <button onClick={handleAddNewPricePart}>Добавить</button>
                    </div>
                </div>
            )}

            {showEditPart && (
                <div className="modal">
                    <div className="modal-content">
                        <button className="close-btn" onClick={() => setShowEditPart(false)}>✖</button>
                        <h4>Редактировать раздел</h4>
                        <input
                            value={nameEditPricePart}
                            onChange={(e) => setNameEditPricePart(e.target.value)}
                        />
                        <div className="modal-actions">
                            <button onClick={handleDelPricePart}>Удалить</button>
                            <button onClick={handleSavePricePart}>Сохранить</button>
                        </div>
                    </div>
                </div>
            )}

        </div>
    );
};
